import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ThemeService } from "@shared/services/theme/theme.service";

@Component({
  selector: "app-top-logo",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./top-logo.component.html",
  styleUrls: ["./top-logo.component.scss"],
  imports: [CommonModule],
})
export class TopLogoComponent {
  readonly themeService: ThemeService = inject(ThemeService);
}
